/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Toggle_HideInputs */

const en_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Subtitle Styling`)
};

const fr_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer le style des sous-titres`)
};

const de_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelformatierung ausblenden`)
};

const it_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi stile sottotitoli`)
};

const ru_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыть стиль субтитров`)
};

const es_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar el estilo de los subtítulos`)
};

const zh_cn2_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐藏副标题样式`)
};

const ja_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕スタイルを非表示`)
};

const hi_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक शैली को छुपाएँ`)
};

const pt_pt2_video_export_style_toggle_hide = /** @type {(inputs: Video_Export_Style_Toggle_HideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar estilo de legenda`)
};

/**
* | output |
* | --- |
* | "Hide Subtitle Styling" |
*
* @param {Video_Export_Style_Toggle_HideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_toggle_hide = /** @type {((inputs?: Video_Export_Style_Toggle_HideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Toggle_HideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_style_toggle_hide(inputs)
	if (locale === "de") return de_video_export_style_toggle_hide(inputs)
	if (locale === "it") return it_video_export_style_toggle_hide(inputs)
	if (locale === "ru") return ru_video_export_style_toggle_hide(inputs)
	if (locale === "es") return es_video_export_style_toggle_hide(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_style_toggle_hide(inputs)
	if (locale === "ja") return ja_video_export_style_toggle_hide(inputs)
	if (locale === "hi") return hi_video_export_style_toggle_hide(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_style_toggle_hide(inputs)
	return en_video_export_style_toggle_hide(inputs)
});